import { render, staticRenderFns } from "./page-dataOrder.vue?vue&type=template&id=3ec56c56&scoped=true&"
import script from "./page-dataOrder.vue?vue&type=script&lang=js&"
export * from "./page-dataOrder.vue?vue&type=script&lang=js&"
import style0 from "./page-dataOrder.vue?vue&type=style&index=0&id=3ec56c56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec56c56",
  null
  
)

export default component.exports